import { ContactReasonItemIcon, ContactReasonItemText } from 'types/UsersAndContact.types';

export const CONTACT_REASONS_TYPE = {
  fire: {
    id: 100,
    text: ContactReasonItemText.Fire,
    icon: ContactReasonItemIcon.Fire,
    color: 'orange',
    enabled: false,
  },
  violation: {
    id: 101,
    text: ContactReasonItemText.Violation,
    icon: ContactReasonItemIcon.Violation,
    color: 'red',
    enabled: false,
  },
  medical: {
    id: 102,
    text: ContactReasonItemText.Medical,
    icon: ContactReasonItemIcon.Medical,
    color: 'green',
    enabled: false,
  },
  panic: {
    id: 103,
    text: ContactReasonItemText.Panic,
    icon: ContactReasonItemIcon.Panic,
    color: 'purple',
    enabled: false,
  },
};
